import React from "react";

const ConfirmIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 68 68'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M33.8532 24.6917C35.8373 24.6917 37.4156 23.2938 37.4156 21.3548C37.4156 19.4158 35.8373 17.9277 33.8532 17.9277C31.8241 17.9277 30.2909 19.4158 30.2909 21.3548C30.2909 23.2938 31.8241 24.6917 33.8532 24.6917ZM30.9673 49.583H36.7843V27.3522L30.9673 28.5697V49.583Z'
        fill={fill}
      />
      <circle cx='34' cy='34' r='30.5' stroke={fill} strokeWidth='7' />
    </svg>
  );
};

ConfirmIcon.defaultProps = {
  width: 68,
  height: 68,
  fill: "white",
};

export default ConfirmIcon;
